import { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import useApi from '../../services/useApi';
import { useRecoilState } from 'recoil';
import { taskListFilterState,namespaceState, selectedTaskState } from '../../recoil/atoms';
import ContextMenu from '../ContextMenu';
import styles from './MyTask.module.css';
import { taskStatusColor } from '../../constants';
import useInterval from '../../hooks/useInterval';
import NaviButton from '../NaviButton';

const Row=({data,onChanged})=>{
    const [, setSelectedTask] = useRecoilState(selectedTaskState);
    const [nsState,]=useRecoilState(namespaceState);
    const navigate = useNavigate();

    const handleNavigation=()=>{
        setSelectedTask(data)

        window.location.href='/task-detail';
        // if (!document.startViewTransition) {
        //   return navigate('/task-detail/'+data.taskId);
        // } else {
        //   return document.startViewTransition(() => {
        //     navigate('/task-detail/'+data.taskId);
        //   });
        // }
    }

    const handleStopTask=(e)=>{
        e.stopPropagation()
        useApi.put('ngp/fl/task/'+data.taskId+'?namespaceId='+nsState.id,'STOP').then((res)=>{
          onChanged();
        });
    }

    const handleDeleteTask=(e)=>{
        e.stopPropagation()
        useApi.delete('ngp/fl/task/'+data.taskId+"?namespaceId="+nsState.id).then((res)=>{
            onChanged();
        });
    }

    return(
        <div 
        className={styles['row']} 
        onClick={handleNavigation}>
            <div className={styles['row-title']}>
                <div className={styles['row-dot']} style={{background:taskStatusColor[data.taskState.toLowerCase()]}}></div>
                <span>{data.taskName}</span>
            </div>
            <span className={styles['row-round']}>
                {data.currentRoundNum===0?0:data.currentRoundNum-1}/
                {data.numOfTestDevice>0?data.maxRound+1:data.maxRound} Round
            </span>
            <div className={styles['action']}>
                <button 
                className={`${data.taskState!=='RUNNING' && styles['action-disabled']}`}
                onClick={handleStopTask}/>
                <button
                onClick={handleDeleteTask}/>
            </div>
        </div>
    )
}

export default function MyTask(){
    const userId=JSON.parse(localStorage.getItem("account")).id;
    const [nsState,setNsState]=useRecoilState(namespaceState);
    const [selectedTab,setSelectedTab]=useState('latest');
    const [listLatestData,setListLatestData]=useState([])
    const [listRunData,setListRunData]=useState([])

    const cancelToken = axios.CancelToken;
    let cancelApi = cancelToken.source();

    const getTaskListLatest=()=>{
      useApi.get('ngp/fl/task/list?namespaceId='+nsState.id+'&'+'userId='+userId
      +'&size='+8 
      ,{
        cancelToken: cancelApi.token
      }).then((res)=>{
        setListLatestData(res.data.items);
      }).catch(function (thrown) {
        if (axios.isCancel(thrown)) {
          console.log('Request canceled', thrown.message);
        } else {
        }
      });
    }

    const getTaskListRun=()=>{
      useApi.get('ngp/fl/task/list?namespaceId='+nsState.id+'&'+'userId='+userId
      +'&size='+50
      ,{
        cancelToken: cancelApi.token
      }).then((res)=>{
        setListRunData(res.data.items.filter(item=>item.taskState==='RUNNING').slice(0,8));
      }).catch(function (thrown) {
        if (axios.isCancel(thrown)) {
          console.log('Request canceled', thrown.message);
        } else {
        }
      });
    }

    useEffect(()=>{
        getTaskListLatest();
        getTaskListRun();
    },[])

    useInterval(() => {
        // cancelApi.cancel("Api Cancel");
        // cancelApi = cancelToken.source();
        getTaskListLatest();
        getTaskListRun();
    }, 60000);

    return(
    <ContextMenu
        renderBtn={({ref, onClick})=>(
            <div 
            ref={ref}
            className={styles['btn']}
            onClick={onClick}
            >
                <span>My Task</span>
                <div className={`${listRunData.length===0?styles['btn-dot-done']:styles['btn-dot-run']}`}>{listRunData.length} Running</div>
                <div className={styles['menu-tip']}>My Task</div>
            </div>
        )} 
        renderMenu={()=>(
            <div className={styles['list-wrap']}>
                <div className={styles['list-header']}>
                    <span className={`${styles['tab']} ${selectedTab!=='latest'&&styles['tab-off']}`}onClick={()=>setSelectedTab('latest')}>Latest</span>
                    <span className={`${styles['tab']} ${selectedTab!=='running'&&styles['tab-off']}`}onClick={()=>setSelectedTab('running')}>Running</span>
                </div>
                <div className={styles['list-body']}>
                    {
                        selectedTab==='latest'?listLatestData.map(item=>
                            <Row 
                            data={item}
                            onChanged={getTaskListLatest}/>
                        )
                        :listRunData.map(item=>
                            <Row 
                            data={item}
                            onChanged={getTaskListRun}
                            />
                        )

                    }
                </div>
                <NaviButton 
                to="/task-list" 
                className={styles['list-footer']}>
                    See more
                </NaviButton>
            </div>
        )}
        menuClassName={styles['wrap']}
        menuAnchor='rightBottom'
        menuHeight={394+14}
        menuShow={true}
    >
    </ContextMenu>
    )
}